export const getGreeting = (): string => {
    const currentHour = new Date().getHours();

    if (currentHour < 12) {
        return "Goedemorgen";
    } else if (currentHour < 18) {
        return "Goedemiddag";
    } else {
        return "Goedenavond";
    }
};
